import INVITE_FRIEND from './invite-friend/types';

export default {
  ...INVITE_FRIEND,
};
